module.exports = __webpack_public_path__ + "img/online-payment.1d2e8c65.webp";